import styles from './DishView.module.scss';
import React from 'react';
import { DishForView } from '../model/Dish';
import Grid from '@material-ui/core/Grid';
import { useIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import { getAmountTypeString } from '../Util/Dish';

interface Props {
  dish: DishForView;
}

function DishView(props: Props) {
  const dishAmount = props.dish.getAmount();
  const intl = useIntl();
  const amountStr = dishAmount
    ? `${dishAmount.value} ${getAmountTypeString(intl, dishAmount.type)}`
    : '';
  return (
    <Grid
      container
      direction='row'
      spacing={0}
      className={styles.DishView}
      alignItems="center">
      <Grid item xs={9} className={styles.leftCol}>
        <Typography variant="h6" className={styles.name}>{props.dish.getName()}</Typography>
        <p className={styles.under}>{props.dish.getDescription()}</p>
        <p className={styles.under}>{amountStr}</p>
      </Grid>
      <Grid item xs={3} className={styles.rightCol}>
      <Typography variant="h6" className={styles.price}>{props.dish.getPriceZl()} zł</Typography>
      </Grid>
    </Grid>
  );
}

export default DishView;
